import GoogleChromeSvg from '../../images/google-chrome.svg';

import './MarketingBannerV2.scss';

const MarketingBannerV2 = ({
  title,
  description,
  ctaLabel,
  ctaURL,
  backgroundImage,
}) => (
  <a
    href={ctaURL ?? '#'}
    className="MarketingBannerV2"
    style={{ backgroundImage: `url(${backgroundImage})` }}
  >
    <div className="MarketingBannerV2__container">
      <div className="MarketingBannerV2__container-title">
        {title}
      </div>
      <div className="MarketingBannerV2__container-description">
        {description}
      </div>
      {ctaLabel && (
        <div className="MarketingBannerV2__container-cta">
          <img
            src={GoogleChromeSvg}
            alt="Google Chrome"
            className="MarketingBannerV2__container-cta-icon"
          />
          <span className="MarketingBannerV2__container-cta-text">
            {ctaLabel}
          </span>
        </div>
      )}
    </div>
  </a>
);

export default MarketingBannerV2;
